import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCallLink } from "../Call/components/CallLinks";
import { setUnitFilter } from "../features/callPlayer/callPlayerSlice";
import { talkgroupNameFor, groupForTalkgroup } from "./demoHelpers";
import DemoSparkline from "./DemoSparkline";

// Rendered inside the console when expanded — a desktop panel, a bottom sheet on
// mobile (see demo.css). Retired as a standalone sticky rail.
function DemoDetail({ call, callsData, talkgroupsData, groupsData }) {
  const dispatch = useDispatch();
  const showTranscripts = useSelector((s) => s.callPlayer.showTranscripts);
  const { callDownload } = useCallLink(call || false);
  const [copied, setCopied] = useState(false);

  const copyLink = () => {
    if (!callDownload || !navigator.clipboard) return;
    navigator.clipboard.writeText(callDownload).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };

  if (!call) {
    return (
      <div className="demo-detail demo-detail-empty">
        Pick a call from the feed, or wait for the next transmission.
      </div>
    );
  }
  const time = new Date(call.time);
  const group = groupForTalkgroup(call.talkgroupNum, groupsData);
  const tgName = talkgroupNameFor(call.talkgroupNum, talkgroupsData);
  const units = call.srcList || [];

  return (
    <div className="demo-detail">
      <div className="demo-detail-head">
        <span className="demo-detail-group">{group ? group.groupName : "Ungrouped"}</span>
        <h2 className="demo-detail-tg">{tgName}</h2>
        <span className="demo-detail-time demo-mono">
          {time.toLocaleTimeString([], { hour: "numeric", minute: "2-digit", second: "2-digit" })} · {call.len}s
        </span>
      </div>

      <div className="demo-detail-units">
        <div className="demo-detail-label">Units heard</div>
        <ul>
          {units.map((s, i) => {
            const label = s.tag && s.tag !== "N/A" ? s.tag : String(s.src);
            return (
              <li key={i} onClick={() => dispatch(setUnitFilter(label))} title="Filter by this unit">
                {label}<span className="demo-detail-pos">{Math.round(s.pos)}s</span>
              </li>
            );
          })}
          {units.length === 0 && <li className="demo-detail-pos">No unit data</li>}
        </ul>
      </div>

      {showTranscripts && (call.transcript || call.transcriptStatus === "pending" || call.transcriptStatus === "processing") && (
        <div className="demo-detail-transcript">
          <div className="demo-detail-label">Transcript</div>
          {call.transcript
            ? <p className="demo-transcript-text">{call.transcript}</p>
            : <p className="demo-transcript-pending">Transcribing…</p>}
        </div>
      )}

      <div className="demo-detail-spark">
        <div className="demo-detail-label">Recent activity</div>
        <DemoSparkline callsData={callsData} talkgroupNum={call.talkgroupNum} />
      </div>

      <div className="demo-detail-actions">
        <a className="demo-btn" href={callDownload} download>Download</a>
        <button className="demo-btn" onClick={copyLink}>{copied ? "Copied ✓" : "Copy link"}</button>
      </div>
    </div>
  );
}

export default DemoDetail;
